<template>
    <div class="about-main-page">
        <div class="container">
            <div class="page-title" v-if="!isMobileChecker">
                <h1 v-html="
                    currentRoute == '/about' ? aboutPage.about_title : 
                    currentRoute == '/about/history' ? aboutPage.history_title : 
                    currentRoute == '/about/awards' ? aboutPage.awards_title :
                    currentRoute == '/about/companies' ? aboutPage.company_title :
                    currentRoute == '/about/vacancies' ? aboutPage.work_title : false"></h1>
            </div>
            <div class="about-baner-pic">
                <div class="pic-item" :style="!isMobileChecker ? 'background-image: url(' + aboutPage.about_baner_img + ')' : 'background-image: url(' + aboutPage.about_baner_img_mobile + ')'"></div>
                <h2>{{ aboutPage.about_baner_title }}</h2>
            </div>
            <div class="content-container">
                <div class="col-left" ref="aboutPageNav" :class="{'fixed-nav' : fixedAoutSalesNav, 'plus-top' : headerTopVisible, 'fixed-bottom' : fixedBottomSalesNav}" :style="[fixedAoutSalesNav == true ? {left : navLeftOffset + 'px'} : {left: 0} ]">
                    <div class="about-navigation"  ref="aboutInNav">
                        <ul ref="aboutNavlist">
                            <li v-for="item in aboutPage.about_nav">
                                <router-link :to="{ name: item.href }" @click.native="scrollIntoView">{{ item.name }}</router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="page-title-mobile" v-if="isMobileChecker">
                        <h1 v-html="
                            currentRoute == '/about' ? aboutPage.about_title : 
                            currentRoute == '/about/history' ? aboutPage.history_title : 
                            currentRoute == '/about/awards' ? aboutPage.awards_title :
                            currentRoute == '/about/companies' ? aboutPage.company_title :
                            currentRoute == '/about/vacancies' ? aboutPage.work_title : false"></h1>
                    </div>
                </div>
                <div class="col-right">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <formPage></formPage>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import formPage from '@/components/forms/form-page.vue'
    export default {
        name: 'about--page',
        components: {
            formPage,
        },
        data () {
            return {
                currentRoute: this.$router.history.current.path,
                scrollPosition: 0,
                navTopOffset: null,
                navLeftOffset: 10,
                headerTopVisible: false,
                fixedAoutSalesNav: false,
                fixedBottomSalesNav: false,
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            getPos() {
                this.navLeftOffset = this.$refs.aboutPageNav.getBoundingClientRect().left
                this.navTopOffset = this.$refs.aboutPageNav.getBoundingClientRect().top
                // console.log(this.navLeftOffset);
            },
            scrollIntoView() {
                const container = this.$refs.aboutInNav;
                const list = this.$refs.aboutNavlist;
                const activeElement = list.querySelector('.router-link-exact-active');
                if (container && list && activeElement) {
                    const containerRect = container.getBoundingClientRect();
                    const elementRect = activeElement.getBoundingClientRect();
                    const activeElementLeft = elementRect.left;
                    container.scrollLeft = activeElementLeft - 125;
                }
            }
            // handleScroll() {
            //     var currentScrollPosition = window.scrollY
            //     if(currentScrollPosition < this.scrollPosition){
            //         // console.log("Scrolling up");
            //         // this.$store.commit('setVisibleParamOnScrollEvent', true);
            //         //your desire logic
            //         this.headerTopVisible = true;
            //         if (currentScrollPosition < this.navTopOffset) {
            //             this.fixedAoutSalesNav = false;
            //             this.headerTopVisible = false;
            //         } 
            //         if (currentScrollPosition < 1840) {
            //             this.fixedBottomSalesNav = false;
            //         }
            //     }
            //     else {
            //         // this.showFullNav = false
            //         console.log("Scrolling down", currentScrollPosition);
            //         if (currentScrollPosition > this.navTopOffset) {
            //             console.log('true')
            //             this.fixedAoutSalesNav = true;
            //             this.headerTopVisible = false;
            //         } 
            //         if (currentScrollPosition > 1840) {
            //             this.fixedBottomSalesNav = true;
            //         }
            //         //your desire logic 
            //     }
            //     this.scrollPosition = window.scrollY
            // }, 
        },
        beforeRouteEnter (to, from, next) {
            // store.dispatch('getNewsItems');
            // store.dispatch('getIndexPageData');
            store.dispatch('getSalesItems');
            if (store.state.aboutPage != null) {
                next(vm => {
                    vm.scrollIntoView();
                });
                // next(vm => {
                //     // vm.$store.commit('removePageLoaderImg');
                //     setTimeout(() => {
                //         vm.$parent.$refs.topProgress.done();
                //     }, 300);
                // });
            } else {
                store.dispatch('getAboutPageData').then((response) => {
                    if (response) {
                        next(vm => {
                            vm.scrollIntoView();
                        });
                        // next(vm => {
                        //     // vm.$store.commit('removePageLoaderImg');
                        //     setTimeout(() => {
                        //         vm.$parent.$refs.topProgress.done();
                        //     }, 300);
                        // });
                    } else {
                        next(false);
                    }
                });
            }
        },
        beforeCreate() {
            document.body.dataset.page = 'about';
        },
        created () {
        },
        mounted() {
            this.getPos();
            this.scrollIntoView();
            // window.addEventListener("scroll", this.handleScroll);
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about-page/about-page.scss';
    @import '@/styles/components/about-page/respond/about-page-respond.scss';
</style>